<template>
    <div>
        <v-tooltip bottom v-if="texto && texto.length > tamanho && tamanhoJanela.x >= 720">
            <template slot="activator">
                <span>{{ texto | azClipText(tamanho) }}</span>
            </template>
            <span>{{ texto }}</span>
        </v-tooltip>
        <span v-else>{{ texto }}</span>
    </div>
</template>

<script>
export default {
    name: 'ExpansaoTexto',
    props: ['tamanho', 'texto'],
    data() {
        return {
            tamanhoJanela: {
                x: 0,
                y: 0
            }
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    methods: {
        handleResize () {
            this.tamanhoJanela = {
                x: window.innerWidth,
                y: window.innerHeight
            }
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style scoped lang="stylus">

</style>